import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const MessagesComponent = () => <ToastContainer draggable={false} duration={3000} />;

export default MessagesComponent;
